// extracted by mini-css-extract-plugin
export default {"portal":"Portal_portal__R4KYH"};